export default {
      id: "Icon_Button_Not Editable-usage",
      viewBox: "1 1 22 24",
      url: __webpack_public_path__ + "img/icons.svg#Icon_Button_Not Editable",
      toString: function () {
        return this.url;
      }
    }